import React, { PureComponent } from 'react';

class TituloIntegrante extends PureComponent {

    render() {
        const {tarjetas,data} = this.props;

        let comienzaEn = 2
        let nombre = this.props.cliente ? this.props.cliente.identidadCliente: "";

        if(tarjetas && tarjetas.tipoEmpresa.EmpresaIndividuos == "E") comienzaEn = 1

        if(this.props.idAdicional == 0){
            return (
                <h1>Nuevo Integrante Nro. {this.props.tarjetas.solicitudCuenta.cuentasAdicionales.length + comienzaEn + " - "+nombre}</h1>
         )
        }else if(this.props.idAdicional>0){
            return (
                <h1>Edición Integrante {nombre}</h1>
         )
        }else{
            return (
                <h1>Edición Integrante</h1>
            )
        }
    }
};

export default TituloIntegrante;